/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gym_Not_FoundInputs */

const en_us2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That gym is no longer saved.`)
};

const pt_br2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa academia não está mais salva.`)
};

const es_419_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese gimnasio ya no está guardado.`)
};

const pt_pt2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse ginásio já não está guardado.`)
};

const fr_fr2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette salle n'est plus enregistrée.`)
};

const de_de2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Studio ist nicht mehr gespeichert.`)
};

const it_it2_gym_not_found = /** @type {(inputs: Gym_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa palestra non è più salvata.`)
};

/**
* | output |
* | --- |
* | "That gym is no longer saved." |
*
* @param {Gym_Not_FoundInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gym_not_found = /** @type {((inputs?: Gym_Not_FoundInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gym_Not_FoundInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gym_not_found(inputs)
	if (locale === "es-419") return es_419_gym_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_gym_not_found(inputs)
	if (locale === "fr-FR") return fr_fr2_gym_not_found(inputs)
	if (locale === "de-DE") return de_de2_gym_not_found(inputs)
	if (locale === "it-IT") return it_it2_gym_not_found(inputs)
	return en_us2_gym_not_found(inputs)
});
export { gym_not_found as "gym.not_found" }